import store from "../store";
import enhanceCanvas from "../bvcomponents/visComponents/canvasEnhancements";
import Misc from "./misc";
import {IS_DASHBOARD_MESSAGING, IS_LIXIL_UI} from "../config";

const createCanvas = (width, height) => {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  let backCtx = canvas.getContext('2d');
  // backCtx.fillStyle = "#FFFFFF";
  // backCtx.fillRect(0, 0, canvas.width, canvas.height);
  return {canvas, backCtx}
}

const finishDraw = async (images, errorImages, layers, size = null, backgroundLayers = [], quality, useNewEnhance = false, exportAsPNG = false, cutImageByItsSides = false) => {

  //0) delete images that couldn't be loaded
  if (errorImages && errorImages.length) {
    images = images.filter(image => image && image.src && !errorImages.includes(image.src));
  }

  const width = size ? size.width : 720; // 1920
  const height = size ? size.height : 405; // 1080
  const maxWidth = 1920;
  const maxHeight = 1080;

  // 1) create canvas
  const canvasObject1 = createCanvas(width, height);
  if (!exportAsPNG) { // keep the background transparent for PNG export
    canvasObject1.backCtx.fillStyle = "#FFFFFF";
    canvasObject1.backCtx.fillRect(0, 0, canvasObject1.canvas.width, canvasObject1.canvas.height);
  }
  const canvasObject3 = createCanvas(maxWidth, maxHeight); // for crops

  // 2) put all background layout layers
  if (backgroundLayers.length) {
    const canvasObject2 = createCanvas(width, height);
    canvasObject2.backCtx.globalCompositeOperation = "lighten";
    images.forEach((imageObject) => {
      const layer = backgroundLayers.find(layer => layer.image === imageObject.src);
      if (layer) {
        if (layer.cropCoords && (document.kvConfig.visualizerType !== "kvScene")) {
          canvasObject3.backCtx.clearRect(0, 0, maxWidth, maxHeight);
          let layerWidth = layer.cropCoords[2] - layer.cropCoords[0];
          let layerHeight = layer.cropCoords[3] - layer.cropCoords[1];
          canvasObject3.backCtx.drawImage(imageObject, 0, 0, layerWidth, layerHeight, layer.cropCoords[0], layer.cropCoords[1], layerWidth, layerHeight);
          canvasObject3.backCtx.drawImage(canvasObject3.canvas, 0, 0, maxWidth, maxHeight,0, 0, width, height);
        } else if (layer.layerDimensions) {
          const dim = layer.layerDimensions;
          // console.log('yep', dim.width, dim.height, dim.polygonArray[0][0], dim.polygonArray[0][1], dim.width, dim.height);
          canvasObject2.backCtx.drawImage(imageObject, 0, 0, dim.width, dim.height, dim.polygonArray[0][0], dim.polygonArray[0][1], dim.width, dim.height);
        } else {
          imageObject.width = width;
          imageObject.height = height;
          canvasObject2.backCtx.drawImage(imageObject, 0, 0, width, height);
        }
      }
    });
    enhanceCanvas(canvasObject2.canvas, useNewEnhance);
    canvasObject1.backCtx.drawImage(canvasObject2.canvas, 0, 0, width, height, 0, 0, width, height);
  }

  // 3) put all layout layers
  for (const loadedImage of images) {
    const layer = layers.find(layers => layers.image === loadedImage.src);
    if (layer && backgroundLayers.every(layer => layer.image !== loadedImage.src)) {
      if (layer.cropCoords) {
        canvasObject3.backCtx.clearRect(0, 0, maxWidth, maxHeight);
        let layerWidth = layer.cropCoords[2] - layer.cropCoords[0];
        let layerHeight = layer.cropCoords[3] - layer.cropCoords[1];
        canvasObject3.backCtx.drawImage(loadedImage, 0, 0, layerWidth, layerHeight, layer.cropCoords[0], layer.cropCoords[1], layerWidth, layerHeight);
        await canvasObject1.backCtx.drawImage(canvasObject3.canvas, 0, 0, maxWidth, maxHeight,0, 0, width, height);
        // } else if (loadedImage.layerDimensions) {
        //   console.log("loadedImage layerDimensions", loadedImage.layerDimensions, loadedImage.src);
        //   const dim = loadedImage.layerDimensions;
        //   // console.log('yep', dim.width, dim.height, dim.polygonArray[0][0], dim.polygonArray[0][1], dim.width, dim.height);
        //   canvasObject1.backCtx.drawImage(loadedImage, 0, 0, dim.width, dim.height, dim.polygonArray[0][0], dim.polygonArray[0][1], dim.width, dim.height);
        // } else if (loadedImage.coords) {
        //   const min_x = width*loadedImage.coords.min_x;
        //   const min_y = height*loadedImage.coords.min_y;
        //   canvasObject1.backCtx.drawImage(loadedImage, 0, 0, loadedImage.width, loadedImage.height, min_x, min_y, loadedImage.width, loadedImage.height);
      } else {
        loadedImage.width = width;
        loadedImage.height = height;
        await canvasObject1.backCtx.drawImage(loadedImage, 0, 0, width, height);
      }
      if (Misc.isMobile() && IS_LIXIL_UI) { // we have to add some time for mobile safari, because of the process stuck
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }
  }
  // 4) cut the canvas by the layers' bounding box (with some padding on the sides)
  if (cutImageByItsSides) {
    const bounds = layers.reduce((acc, layer) => {
      if (!layer.cropCoords || layer.partId === "shower_wall") {
        return acc
      }
      return [
        Math.min(acc[0], layer.cropCoords[0]),
        Math.min(acc[1], layer.cropCoords[1]),
        Math.max(acc[2], layer.cropCoords[2]),
        Math.max(acc[3], layer.cropCoords[3]),
      ]
    }, [Infinity, Infinity, -Infinity, -Infinity]);

    if (bounds[0] !== Infinity) { // at least one layer had cropCoords
      // const padding = 20;
      const padding = 0;
      const x1 = Math.max(0, bounds[0] - padding);
      const y1 = Math.max(0, bounds[1] - padding);
      const x2 = Math.min(maxWidth, bounds[2] + padding);
      const y2 = Math.min(maxHeight, bounds[3] + padding);
      // cropCoords live in maxWidth x maxHeight space, scale them down to the output canvas
      const scaleX = width / maxWidth;
      const scaleY = height / maxHeight;
      const cutWidth = Math.round((x2 - x1) * scaleX);
      const cutHeight = Math.round((y2 - y1) * scaleY);
      const cutCanvasObject = createCanvas(cutWidth, cutHeight);
      cutCanvasObject.backCtx.drawImage(canvasObject1.canvas, x1 * scaleX, y1 * scaleY, (x2 - x1) * scaleX, (y2 - y1) * scaleY, 0, 0, cutWidth, cutHeight);
      if (exportAsPNG) {
        return cutCanvasObject.canvas.toDataURL("image/png")
      }
      return cutCanvasObject.canvas.toDataURL("image/jpeg", quality)
    }
  }

  // png is much heavier (~5.8Mb vs ~600Kb jpeg), so use it only when transparency is required
  if (exportAsPNG) {
    return canvasObject1.canvas.toDataURL("image/png")
  }
  return canvasObject1.canvas.toDataURL("image/jpeg", quality)
};

const getSubscriptionThumbnail = () => {
  const fabricatorState = store.getState().fabricatorState;
  if (fabricatorState.fabricatorSubscriptions) {
    let thumbnail = "";
    fabricatorState.fabricatorSubscriptions.forEach((subscription) => {
      if (subscription.thumbnail) {
        thumbnail = subscription.thumbnail
      }
    });
    return thumbnail
  }
  return ""
}

/**
 * A PROMISE! Returns the whole canvas image
 * @param layout
 * @param size
 * @param quality {number}
 * @param useNewEnhance {boolean}
 * @param onlyRenderGroups {FeatureGroup[]}
 * @param exportAsPNG {boolean} - export as png with a transparent background (jpeg with white background otherwise)
 * @param cutImageByItsSides {boolean} - cut the result by the bounding box of the layers' cropCoords (+20px padding, clamped to the canvas)
 */
export const getImagePromiseFromLayout = (layout,
                                          size = null,
                                          quality = 0.7,
                                          useNewEnhance = false,
                                          onlyRenderGroups = null,
                                          exportAsPNG = false,
                                          cutImageByItsSides = false) => {
  if (!layout || IS_DASHBOARD_MESSAGING) {
    return Promise.resolve(getSubscriptionThumbnail())
  }
  const showPlaceHolders = document.bvConfig ? document.bvConfig.showPlaceholders : false;

  let layers = layout.getLayers(showPlaceHolders, true);
  if (Array.isArray(onlyRenderGroups) && onlyRenderGroups.length) {
    // console.log("layers before", layers);
    layers = layers.filter(layer => onlyRenderGroups.some(fg => fg.partId === layer.partId));
    // console.log("layers after", layers);
  }
  if (!layers.length) {
    return Promise.resolve(getSubscriptionThumbnail())
  }

  const backGroundLayers = getBackgroundLayers(layers, layout);
  let imagesPromise = new Promise((resolve) => {
    let cnt = 0;
    const images = [];
    const errorImages = [];
    layers.forEach((layer) => {
      const image = new Image();
      image.crossOrigin = 'Anonymous';
      image.layerDimensions = layer.layerDimensions || null;
      image.coords = layer.coords || null;
      images.push(image);
      image.onload = () => {
        cnt++;
        if (cnt === layers.length) {
          resolve(finishDraw(images, errorImages, layers, size, backGroundLayers, quality, useNewEnhance, exportAsPNG, cutImageByItsSides))
        }
      };
      image.onerror = () => {
        //display error
        console.error('Coudn\'t load image:', image.src);
        cnt++;
        errorImages.push(image.src);
        if (cnt === layers.length) {
          resolve(finishDraw(images, errorImages, layers, size, backGroundLayers, quality, useNewEnhance, exportAsPNG, cutImageByItsSides))
        }
      };
      try {
        image.src = layer.image;
      } catch (e) {
        console.log(e, 'Can\'t apply image src', layer.image);
      }
    });
  });
  return imagesPromise.then(response => response)
};

/**
 * @param layers {array}
 * @param layout {object}
 * @param newLayoutType {boolean}
 * @returns layersArray {array}
 */
export const getBackgroundLayers = (layers, layout, newLayoutType = false) => {
  if ((layout && layout.isNewLayout) || newLayoutType) {
    return layers.filter((layer) => layer.zIndex >= 50000)
  }
  if (!layout) { // just in case
    return []
  }
  const name = layout.getCurrentLayoutName();
  return layers.filter((layer) => {
    return layout.zIndexes[name] && layout.zIndexes[name].Background &&
      Object.values(layout.zIndexes[name].Background).some(zIndex => zIndex === layer.zIndex);
  })
};
